import { Injectable } from '@angular/core';
import {ApiService} from "./api.service";
import {CommonUtils} from "../utils/common";
import {VetReservation} from "../models/vet-reservation.model";
import {VetineoApiResponse} from "../models/vetineo-api-response.model";
import {map} from "rxjs/operators";
import {DoctorVisitSurvey} from "../models/doctor-visit-survey.model";

/**
 * NOT USED
 */
@Injectable({
  providedIn: 'root'
})
export class SurveyService {

  private questions: Survey[] = [];

  constructor(private apiService: ApiService, public commonUtils : CommonUtils) {
    this.initFakeQuestions();
  }

  private initFakeQuestions() {
    this.questions.push(new Survey('Oceń jakość wizyty',['1','2','3','4','5','6','7','8','9','10']));
    this.questions.push(new Survey('Oceń komunikatywność klienta',['1','2','3','4','5','6','7','8','9','10']));
  }

  sendAnswers(survey: DoctorVisitSurvey, visitUUID: string){
   return this.apiService.post<VetineoApiResponse>('/api/vet-reservations/doctor-survey/'+visitUUID , survey).pipe(map(vetineoApiResponse => {
      if (vetineoApiResponse.ok) {
        return this.commonUtils.bestTypedArrayCopyEver(new VetReservation(), [], vetineoApiResponse.response);
      } else {
        return undefined;
      }
    }));

  }

  getSurvey(){
    return this.questions
  }
}

export class Survey {
    public question: string;
    public answers: string[];

    constructor(question: string, answers: string[]){
      this.question=question;
      this.answers=answers;
    }

}
